import Tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';
import './scss/tooltip.scss';

export default class Tooltip {

    static removeExisting(element) {
        const container = element || '.tooltip';
        const elements =  container instanceof HTMLElement ? [container] : [...document.querySelectorAll(container)];
        elements?.forEach((el) => el?._tippy?.destroy());
    }

    static init(element, options) {
        const container = element || '.tooltip';
        this.removeExisting(container);
        Tippy(container,
            {
                allowHTML: true,
                interactive: true,
                ...options,
            });
    }
}
